import { combineReducers, createReducer } from '@reduxjs/toolkit';
import { Action } from 'modules/types/common';
import { switchAccountSuccess } from 'store/account/actions';
import { createFetchReducer, DefaultState } from 'store/setLocalStore';
import * as actions from './actions';
import {
  DashboardAnalyticsInterface,
  HighPriorityActionItemsInterface,
  LowPriorityActionItemsInterface
} from './types';

export interface PriorityActionItemsState {
  dashboardAnalytics: DashboardAnalyticsInterface;
  lowPriorityItems: LowPriorityActionItemsState;
  highPriorityItems: HighPriorityActionItemsState;
}

export interface LowPriorityActionItemsState extends DefaultState {
  data?: LowPriorityActionItemsInterface[];
  errors?: string[];
  source?: string[];
}

export interface HighPriorityActionItemsState extends DefaultState {
  data?: HighPriorityActionItemsInterface[];
  errors?: string[] | null;
  source?: string[];
}

const lowPriorityItemsReducer = createFetchReducer<LowPriorityActionItemsInterface[]>(
  actions.GET_LOW_PRIORITY_ITEMS,
  true
);

const highPriorityItemsReducer = createFetchReducer<HighPriorityActionItemsInterface>(
  actions.GET_HIGH_PRIORITY_ITEMS,
  true
);

const lowPriorityItems = (state: LowPriorityActionItemsState, action: Action) => {
  return lowPriorityItemsReducer(state, action);
};

const highPriorityItems = (state: HighPriorityActionItemsState, action: Action) => {
  return highPriorityItemsReducer(state, action);
};

const dashboardAnalyticsReducer = createReducer(
  () => ({
    hasSentDashboardCardAnalytics: false
  }),
  {
    [switchAccountSuccess.type]: state => {
      state.hasSentDashboardCardAnalytics = false;
    },
    [actions.SET_HAS_SENT_DASHBOARD_CARD_ANALYTICS]: state => {
      state.hasSentDashboardCardAnalytics = true;
    }
  }
);

export default combineReducers({
  dashboardAnalytics: dashboardAnalyticsReducer,
  lowPriorityItems,
  highPriorityItems
});
